import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=c453ef50&scoped=true"
import script from "./entrance.vue?vue&type=script&lang=js"
export * from "./entrance.vue?vue&type=script&lang=js"
import style0 from "./entrance.vue?vue&type=style&index=0&id=c453ef50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c453ef50",
  null
  
)

export default component.exports